/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
v3RegistrationApp.controller('tempLoginCtrl', ['$scope', '$routeParams', '$window', 'DebugHelper', 'V3SessionResource', function($scope, $routeParams, $window, DebugHelper, V3SessionResource) {
  DebugHelper.register("tempLoginCtrl", $scope);

  _.assignIn($scope, {
    params: {},
    routes: Packs.iKnowRoutes,
    stateUI: {
      showError: false
    }
  }
  );

  if ($routeParams.access_token) {
    return V3SessionResource.create({temp_login_token: $routeParams.access_token}
    , function(success) {
      if ($routeParams.next_path) {
        return $window.location.href = $routeParams.next_path;
      } else {
        return window.location.href = Packs.iKnowRoutes.v3_dashboard_path();
      }
    }
    , function(error) {
      DebugHelper.logError('Unable to perform one time login with token' + $routeParams.access_token);
      return window.location.href = Packs.iKnowRoutes.v3_dashboard_path();
    });
  } else {
    return window.location.href = Packs.iKnowRoutes.v3_dashboard_path();
  }
}
]);
